module.exports = __webpack_public_path__ + "static/media/ecs-website-design-screen.d2aa999c.jpg";